import { useSession } from "../../../SessionContext";
import { useLanguage } from "../../../../context/LanguageContext";
import { ScreenSequence } from "../Sequences";
import { BandwagonExplanationScreen } from "./ExplanationScreen";
import { BandwagonScreen1 } from "./BandwagonScreen1";
import { BandwagonScreen2 } from "./BandwagonScreen2";
import { BandwagonResultScreen } from "./ResultScreen";
import { ResultScreenGlobal } from "./ResultScreenGlobal";
import { WellDoneScreen } from "../../../WellDoneScreen";

export const BandwagonEffectKey = "BandwagonEffect";

export function useBandwagonSequence(): ScreenSequence {
    const { userData } = useSession();
    const { t } = useLanguage();
    const randomizer3 = userData?.randomizer3 || "Bedingung 1";

    return {
        name: t('experiments', 'bandwagon', 'screens', 'task', 'filmEvening'),
        description: t('experiments', 'bandwagon', 'description'),
        group: "A2",
        screens: [
            randomizer3 === "Bedingung 2"
                ? { component: BandwagonScreen2 }
                : { component: BandwagonScreen1 },
            { component: BandwagonResultScreen },
            { component: ResultScreenGlobal.component },
            { component: BandwagonExplanationScreen },
            {
                component: WellDoneScreen,
                canContinueDefault: false,
            }
        ],
        resultScreenIndex: 1,
        explanationScreenIndex: 3, // now pushed after global
    };
}